import Component from './confirm_dialog.vue'
export default Component
